module.exports = __webpack_public_path__ + "h5/img/billboard-qt.a6917136.png";